
import { useState, useEffect } from 'react';

interface AnimatedLogoProps {
  size?: number;
  className?: string;
  onHero?: boolean;
}

export const AnimatedLogo = ({ size = 24, className = "", onHero = false }: AnimatedLogoProps) => {
  const [colorIndex, setColorIndex] = useState(0);
  const ink = onHero ? '#ffffff' : '#000000';
  const colors = [ink, '#38a169', '#f97316', '#e53e3e', ink];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((current) => (current + 1) % (colors.length - 1));
    }, 2000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className={`transition-all duration-700 ease-in-out ${className}`}>
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke={colors[colorIndex]}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="transition-colors duration-700 ease-in-out"
      >
        <path d="M10 2h4"/>
        <path d="M12 14v-4"/>
        <path d="M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6"/>
        <path d="M9 17H4v5"/>
      </svg>
    </div>
  );
};
